import { getSubscriptionMenuProbeModeSync } from '../../flags/subscriptionMenuProbe';
import { appendSubscriptionMenuProbeLog } from './logger';
import { menuFetchAllowsSelection } from './logic';

/** Per-date menu API probe result for state 2 (per_day). */
const per_day_menu_allowed_by_date = new Map<string, boolean>();

export function recordPerDayMenuFetchResult(date_ymd: string, menu_builders_count: number): boolean {
  const mode = getSubscriptionMenuProbeModeSync();
  if (mode !== 'per_day') {
    return true;
  }
  const gate = menuFetchAllowsSelection(mode, menu_builders_count);
  per_day_menu_allowed_by_date.set(date_ymd, gate.allowed);
  appendSubscriptionMenuProbeLog({
    category: 'menu_fetch',
    label: `per-day gate ${date_ymd}`,
    notes: gate.note,
    request: { date: date_ymd, menu_builders_count },
    response: { selection_allowed: gate.allowed },
  });
  return gate.allowed;
}

export function isPerDayMenuSelectionAllowed(date_ymd: string): boolean {
  if (getSubscriptionMenuProbeModeSync() !== 'per_day') {
    return true;
  }
  return per_day_menu_allowed_by_date.get(date_ymd) ?? false;
}

export function clearPerDayMenuGateCache(): void {
  per_day_menu_allowed_by_date.clear();
}
